<template>
  <v-dialog v-model="this.$store.state.authVar.login" persistent max-width="500px">
    <v-card class="auth-card">
      <v-card-title>
        <span class="headline">{{$t('auth.auth')}}</span><v-spacer></v-spacer>
        <v-btn icon @click="authClose">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field v-model="email" :rules="rules" :label="$t('auth.mail')" required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="password" :rules="rules" :label="$t('auth.pass')" type="password" required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-btn block depressed dark color="indigo"
                   @click="signIn"
                   :loading="signing"
                   :disabled="signing"
            >{{$t('auth.login')}}</v-btn>
          </v-flex>
          <v-flex xs12 mt-4>
            <span class="social-label">{{$t('auth.orWith')}}</span>
          </v-flex>
          <v-flex xs12>
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex d-flex xs6>
                  <v-btn
                      block
                      depressed
                      dark
                      color="error"
                      @click="socialAuth('google')"
                  >
                    <v-icon>fab fa-google</v-icon>&nbsp; Google
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex xs12 mt-4>
            {{$t('auth.notAuth')}} | <a @click="openRecovery">{{$t('auth.recovery')}}</a>
            <v-btn block depressed color="secondary" dark @click="performSignUp">{{$t('auth.reg')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import UserFunc from '@/components/partials/AuthForm'

export default {
  name: 'LoginModal',
  data () {
    return {
      email: '',
      password: '',
      signing: false,
      rules: [(value) => !!value || this.$t('auth.required')],
      fbSignInParams: {
        scope: 'public_profile,email',
        return_scopes: true
      }
    }
  },
  methods: {
    onSignInSuccess (response) {
      // eslint-disable-next-line
      FB.api('/me?fields=name,email,first_name,last_name', dude => {
        UserFunc.fbAuth(this, dude)
      })
    },
    onSignInError (error) {
      this.$notice['error']({
        title: this.$t('auth.error'),
        description: error
      })
    },
    authClose () {
      this.$store.commit('var', { type: 'authVar', i: 'login', v: false })
    },
    performSignUp () {
      this.$store.commit('var', { type: 'authVar', i: 'login', v: false })
      this.$store.commit('var', { type: 'authVar', i: 'signUp', v: true })
    },
    socialAuth (network) {
      UserFunc.helloAuth(this, network)
    },
    signIn () {
      UserFunc.signIn(this)
    },
    openRecovery () {
      this.$store.commit('var', { type: 'authVar', i: 'recovery', v: true })
      this.$store.commit('var', { type: 'authVar', i: 'login', v: false })
    }
  },
  created () {
    /* eslint-disable */
    window.fbAsyncInit = function() {
      FB.init({
        appId      : '1587333081396128',
        cookie     : true,  // enable cookies to allow the server to access the session
        xfbml      : true,  // parse social plugins on this page
        version    : 'v2.8' // use graph api version 2.8
      });
    };
    (function(d, s, id) {
      let js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }
}
</script>

<style scoped>
.fb-btn {

}
</style>



// WEBPACK FOOTER //
// src/components/partials/AuthForm/LoginModal.vue